import { type CSSProperties } from 'react';
import { Sprite } from './Sprite';

/** A light, occasional "read it to your grown-up" moment (Phase 5 co-play / relatedness,
 *  per docs/01 SDT + screen-time co-use guidance). Not a task, no scoring — just a warm
 *  prompt to read the finished mission aloud to a parent. Shown on a cadence, never naggy. */
export function CoPlayPrompt({ line, onDone }: { line: string; onDone: () => void }) {
  return (
    <div style={overlay}>
      <Sprite heroId="spidey" kind="idle" size={120} />
      <div style={title}>📣 Read it to your grown-up!</div>
      <div style={card}>
        <span style={lineText}>{line}</span>
      </div>
      <button type="button" style={btn} onClick={onDone}>
        We did it! 🎉
      </button>
    </div>
  );
}

const overlay: CSSProperties = {
  position: 'fixed',
  inset: 0,
  zIndex: 50,
  background: 'var(--frame)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 18,
  padding: 24,
};
const title: CSSProperties = { fontSize: 26, fontWeight: 800, color: 'var(--gold)', textAlign: 'center' };
const card: CSSProperties = {
  background: 'var(--card)',
  borderRadius: 24,
  padding: '24px 28px',
  maxWidth: 880,
};
const lineText: CSSProperties = {
  fontFamily: 'var(--font-read)',
  fontSize: 'clamp(28px, 5.5vmin, 52px)',
  fontWeight: 800,
  color: 'var(--ink)',
  lineHeight: 1.3,
  textAlign: 'center',
  display: 'block',
};
const btn: CSSProperties = {
  height: 'var(--target-min)',
  padding: '0 40px',
  borderRadius: 999,
  border: 'none',
  background: 'var(--spidey-red)',
  color: '#fff',
  fontSize: 22,
  fontWeight: 800,
  cursor: 'pointer',
};
